import { ApiUnavailableState, LoadingState, NotConfiguredState } from "../components/states";
import { AdminCard, EmptyInline, MetricCard } from "../components/dashboard";
import { Icon } from "../components/icons";
import { usePlatformStatus } from "../hooks/usePlatformStatus";
import { useAppContext } from "../hooks/useAppContext";

/**
 * Analytics — growth and engagement for the connected server. Layout uses the
 * ODIN design system; the stat row and chart cards are driven by real data with
 * honest empty states until a server is connected. No fabricated metrics.
 */

export function Analytics(): JSX.Element {
  const status = usePlatformStatus();
  const { guildName } = useAppContext();
  const ready = status.kind === "ready" ? status.data : null;
  const connected = Boolean(guildName);

  return (
    <div className="ax-content" style={{ gridTemplateColumns: "1fr" }}>
      <div className="ax-workspace">
        <div className="ax-head">
          <div>
            <h1 className="ax-head__title">Analytics</h1>
            <p className="ax-head__sub">Growth and engagement for your connected server.</p>
          </div>
          <span className="ax-btn ax-btn--secondary" aria-disabled="true" style={{ opacity: 0.6, cursor: "not-allowed" }}>
            Last 30 days
          </span>
        </div>

        {status.kind === "loading" ? <LoadingState label="Contacting the control API…" /> : null}
        {status.kind === "not-configured" ? (
          <NotConfiguredState title="Control API URL not configured">
            Set <code>PUBLIC_API_URL</code> when building the dashboard to see live status here.
          </NotConfiguredState>
        ) : null}
        {status.kind === "unavailable" ? <ApiUnavailableState detail={status.detail} /> : null}

        {ready ? (
          <>
            <div className="ax-stats4">
              <MetricCard label="Members" icon={<Icon.members />} value={null} foot={connected ? "Awaiting sync" : "No server"} />
              <MetricCard label="New (30d)" icon={<Icon.userPlus />} iconTone="success" value={null} foot={connected ? "Awaiting sync" : "No server"} />
              <MetricCard label="Messages (30d)" icon={<Icon.analytics />} value={null} foot={connected ? "Awaiting sync" : "No server"} />
              <MetricCard label="Active members" icon={<Icon.heart />} value={null} foot={connected ? "Awaiting sync" : "No server"} />
            </div>

            <div className="ax-sections">
              <AdminCard title="Growth">
                <EmptyInline title="No data yet">Charts appear once a server is connected.</EmptyInline>
              </AdminCard>

              <AdminCard title="Engagement">
                <EmptyInline title="No data yet">Charts appear once a server is connected.</EmptyInline>
              </AdminCard>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
